import { Component, inject, input, OnInit, } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthUserDto, TenantService } from '@artemis-software/wr-api';
import TenantTypeEnum = AuthUserDto.TenantTypeEnum;
import { currentTenantId } from '@/utils/admin-utils';

@Component({
  standalone: false,
  selector: 'wr-tenant-contractor-external-config-page',
  templateUrl: './tenant-contractor-external-config-page.component.html',
  styleUrl: './tenant-contractor-external-config-page.component.scss'
})
export class TenantContractorExternalConfigPageComponent implements OnInit{

  readonly tenantService = inject(TenantService);

  readonly form = input.required<FormGroup>();
  readonly tenantType = input.required<TenantTypeEnum>();
  readonly isEditing = input.required<boolean>();
  readonly firstSubmit = input.required<boolean>();
  readonly contractorId = input.required<string | undefined>();
  readonly currentTenantId = currentTenantId();

  ngOnInit(): void {
    const contractorId = this.getContractorId();
    const currentTenantId = this.currentTenantId();
    if(contractorId && currentTenantId){
      this.tenantService.findContractorExternalConfig(
        contractorId,
        currentTenantId
      ).subscribe(config => {
        this.form().get('contractorExternalConfigId')?.setValue(config.id);
        this.form().get('contractorNumber')?.setValue(config.contractorNumber);
        this.form().get('facilityElements')?.setValue(config.facilityElements);
      });
    }
  }

  hasError(controlName: string, errorName = 'required'): boolean {
    const control = this.form().get(controlName);
    return this.isEditing() && this.firstSubmit() && (control?.hasError(errorName) ?? false) && ((control?.touched ?? false) || (control?.dirty ?? false));
  }

  getContractorId(): string | undefined {
    return this.form().get('id')?.value;
  }
}
